import userApi from "@/api/user-api";

const user = {
  state: {
    userData: {}
  },
  actions: {
    async setUser({commit}) {
        const response = await userApi.get()
        
        if (response.data.data) {
          commit('SET_USER', response.data.data)
        }
    },
  },
  mutations: {
    SET_USER(state, user) {
      state.userData = {...state.userData, ...user}
      console.log('action');
    },
  },
  getters: {
    getUser: (state) => state.userData,
    getUserSchoolCode: (state) => state.userData.school_code,
    isUserAllowModify: (state) => !!state.userData.permissions && state.userData.permissions.some(x => x === 'org_account.write') && false
  }
}

export default user
